<template>
  <div class="footer">
    <footer>
        <ul>
          <div class='inner'>
          <li><a href="https://gojou-lawfirm.com/about/" target="_blank" rel="noopener">事務所概要</a></li>
          <li><a href="https://gojou-lawfirm.com/privacy-policy/" target="_blank" rel="noopener">プライバシーポリシー</a></li>
          </div>
          <li class="copyright">©{{yaer}} <router-link to="/">弁護士法人ラピス法律事務所</router-link></li>
        </ul>
    </footer>
  </div>
</template>

<script>

export default {
    name: 'Footer',
    data() {
      return {
        yaer: new Date().getFullYear()
      }
    },
}
</script>

<style scoped lang="scss">

.footer {
  margin-top: auto;
  background: #152924;
}
footer {
  width: 100%;
  margin: auto;
  color: #FFF;
  ul {
    margin: auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    padding: 0.5rem;
    justify-content: center;

    .inner{
      display: flex;

      @media (max-width: 767px) {
            flex-wrap: wrap;
            width: calc(100% - 74px);
        }
    }

    li {
      padding: 0 0.4rem;
      text-align: left;
      font-size: 0.875rem;

      @media (max-width: 767px) {
            flex-basis: 40%;

          &:nth-child(2n){
            flex-basis: 60%;
          }
        }

      &.copyright {
        margin-left: auto;
        font-size: 0.6875rem;
        text-align: center;
        flex-basis: 100%;
        margin: 1rem auto 0 auto;
        a {
          &:before {
            content: none;
          }
        }
      }
      a {
        text-decoration: none;
        color: #FFF;
        &:before {
          content: '›';
          margin-right: 0.5rem;
          font-size: 1.25rem;
        }
        &:hover {
          color: #fff830;
        }
      }
    }
  }
}
</style>
